import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import { InputField } from 'components/common/FormElements/Input'
import Rules from 'components/common/Rules/Rules'
import Banner from 'components/common/Banner/Banner'
import Media from 'components/common/Media'
import model from './changePasswordViewModel'
import { registerPasswordField } from './helpers'
import { Buttons } from '../Shared.styles'
import { rules } from './validationRules'

const OldPasswordField = registerPasswordField('oldPassword')
const NewPasswordField = registerPasswordField('newPassword')
const NewPasswordConfirmationField = registerPasswordField('confirmPassword')

const ChangePasswordForm = ({
  onCancel,
  formValues,
  handleSubmit,
  isNewPasswordDirty,
  isNewPasswordActive,
  error,
  setFocusScopeRef,
  submitFailed,
  submitting
}) =>
  <React.Fragment>
    {
      submitFailed && error &&
        <CustomBanner error_alternative>
          { error }
        </CustomBanner>
    }
    <div>
      <Row>
        <Cell ref={ setFocusScopeRef } data-at-accountdetails-currentpassword-wrapper>
          <InputTextField { ...model.oldPassword } component={ OldPasswordField } full static />
        </Cell>
      </Row>
      <Row>
        <Cell>
          <InputWrapper data-at-accountdetails-newpassword-wrapper>
            <InputTextField { ...model.password } component={ NewPasswordField } full static />
          </InputWrapper>
          <InputWrapper data-at-accountdetails-confirmpassword-wrapper>
            <InputTextField { ...model.confirmPassword } component={ NewPasswordConfirmationField } full static />
          </InputWrapper>
        </Cell>
        <Media.Desktop>
          <Cell>
            <Rules data-at-password-rules dirty={ !!isNewPasswordDirty } active={ isNewPasswordActive } rules={ rules } values={ formValues } margin="0 0 0 1.667em" />
          </Cell>
        </Media.Desktop>
        <Media.Mobile>
          <Cell>
            <Rules dirty={ !!isNewPasswordDirty } active={ isNewPasswordActive } rules={ rules } values={ formValues } margin="10px 0 0" />
          </Cell>
        </Media.Mobile>
      </Row>
    </div>
    <Buttons>
      <Button data-at-security-save-button disabled={ submitting } onClick={ handleSubmit }>Save</Button>
      <Button data-at-security-cancel-button link onClick={ onCancel }>Cancel</Button>
    </Buttons>
  </React.Fragment>

export default ChangePasswordForm

ChangePasswordForm.propTypes = {
  error: PropTypes.string,
  formValues: PropTypes.shape(),
  handleSubmit: PropTypes.func,
  isNewPasswordActive: PropTypes.bool,
  isNewPasswordDirty: PropTypes.string,
  onCancel: PropTypes.func,
  setFocusScopeRef: PropTypes.func,
  submitFailed: PropTypes.bool,
  submitting: PropTypes.bool
}

const Cell = styled.div`
  display: inline-block;
  width: 16.285em;
  vertical-align: top;
  margin-right: 25px;
  ${Media.mobile`
    width: 100%;
    margin-right: 0;
  `}
`

const Row = styled.div`
  position: relative;

  & + & {
    margin-top: 15px;
  }
`

const CustomBanner = styled(Banner)`
  padding-top: 0;
  margin-bottom: 25px;
`

const InputTextField = styled(InputField)`
  & [data-error-message] {
    margin-bottom: 10px;
  }
`
const InputWrapper = styled.div`
  width: 100%;

  & + & {
    margin-top: 15px;
  }
`
